/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState, useContext, useEffect } from 'react';
import {
  Badge,
  Button,
  Checkbox,
  DatePicker,
  Icon,
  Input,
  Modal,
  Tooltip
} from '@scuf/common';
import {
  IAny,
  IRequestContext,
  IsubmitbaselineformrequestBody
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import './EmaasBaselineFormModalCommon.scss';
import { formatDateforSave } from '../../UtilityBillViewDetailsComponent/UtilityBillViewDetailsUtils';
import { getBaselineNotifyInfo } from '../../../shared/Utils/UtilitySettings/UtilitySettingsUtils';
import { ApiContext } from '../../../../context/ApiContext';
import useConnectorForPost from '../../../shared/useConnectorAndDynamicProps/useConnectorForPost';
import useConnectorAndDynamicProps from '../../../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import EmassProgresstab from './EmassProgresstab';

import {
  subDays,
  isAfter as isDateAfter,
  isBefore as isDateBefore
} from 'date-fns';
import _ from 'lodash';

interface EmaasCommonProps {
  openmodal: boolean;
  setOpenmodal: (event: IAny) => void;
  bearerToken?: string;
  requestContext: any;
}

function EmaasBaselineFormModal(props: EmaasCommonProps) {
  const { openmodal, setOpenmodal, bearerToken, requestContext } = props;
  const [t] = useTranslation();
  const d = descriptors.DetailedView;
  const de = descriptors.energyManagement;

  const [progressTab, setProgressTab] = useState(false);
  const [openmodall, setOpenmodall] = useState(false);
  const [closeOnSelection, setCloseOnSelection] = useState(false);
  const [closeOnDocumentClick, setCloseOnDocumentClick] = useState(true);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [error, setError] = useState('');
  const [errorApplyBaselineFrom, setErrorApplyBaselineFrom] = useState('');
  const [errorExclusionFrom, setErrorExclusionFrom] = useState('');
  const [isDatepickerenable, setIsdatepickerenable] = useState(false);
  const [datePickervalue, setDatePickervalue] = useState({
    chooseTrainingdate: {
      from: '',
      to: ''
    },
    startTrainingdate: {
      from: ''
    },
    toggledate: {
      from: '',
      to: ''
    }
  });
  const [issubmitenable, setIssubmitenable] = useState(true);

  useEffect(() => {
    const {
      chooseTrainingdate,
      startTrainingdate,
      toggledate
    } = datePickervalue;
    const areRequiredValuesSelected =
      !_.isUndefined(chooseTrainingdate.from) &&
      chooseTrainingdate.from !== 'Invalid date' &&
      !_.isUndefined(chooseTrainingdate.to) &&
      chooseTrainingdate.to !== 'Invalid date' &&
      !_.isUndefined(startTrainingdate.from);
    const isToggleon = isDatepickerenable;
    // const isToggledateselected = isToggleon? toggledate.from && toggledate.to : true;
    const isToggledateselected = isToggleon
      ? !_.isUndefined(toggledate.from) &&
        !_.isUndefined(toggledate.to) &&
        toggledate.from !== 'Invalid date' &&
        toggledate.to !== 'Invalid date'
      : true;

    const isValidExclusionDates =
      areRequiredValuesSelected && isToggledateselected && isToggleon
        ? isDateAfter(
            new Date(toggledate.from),
            new Date(chooseTrainingdate.from)
          ) &&
          isDateBefore(new Date(toggledate.to), new Date(chooseTrainingdate.to))
        : true;

    if (!isValidExclusionDates) {
      setErrorExclusionFrom(t(d.INVALIDEXCLUSIONRANGESELECTION));
    } else {
      setErrorExclusionFrom('');
    }
    setIssubmitenable(
      !areRequiredValuesSelected ||
        !isToggledateselected ||
        !isValidExclusionDates
    );
  }, [datePickervalue, isDatepickerenable]);

  const apiContext = useContext(ApiContext);
  const { notifyMessage, submitbaselinetrainingform } = apiContext;

  const handleSubmit = async () => {
    setProgressTab(true);
    const requestBody: IsubmitbaselineformrequestBody = {
      trainingStartDate: datePickervalue.chooseTrainingdate.from,
      trainingEndDate: datePickervalue.chooseTrainingdate.to,
      applyBaselineFrom: formatDateforSave(new Date().toDateString()),
      exclusionStartDate: isDatepickerenable
        ? datePickervalue.toggledate.from
        : null,
      exclusionEndDate: isDatepickerenable
        ? datePickervalue.toggledate.to
        : null
    };
    if (submitbaselinetrainingform) {
      const result: IAny = await submitbaselinetrainingform(requestBody);
      const { notifyDescription, notifyType } = getBaselineNotifyInfo(result);
      notifyMessage && notifyMessage(t(notifyDescription), notifyType);
    }
  };
  const openModal = () => {
    setOpenmodall(true);
  };
  const closeModal = () => {
    setOpenmodall(false);
    setOpenmodal(false);
    setProgressTab(false);
  };
  const handleBillingCycle = (to?: IAny, from?: IAny, name?: IAny) => {
    if (name === 'chooseTrainingdate') {
      setDatePickervalue((prevD) => ({
        ...prevD,
        [name]: {
          from: formatDateforSave(
            typeof from === 'object' ? from.toDateString() : ''
          ),
          to: formatDateforSave(typeof to === 'object' ? to.toDateString() : '')
        }
      }));
    }
    if (name === 'startTrainingdate') {
      setDatePickervalue((prevD) => ({
        ...prevD,
        [name]: {
          from: formatDateforSave(
            typeof from === 'object' ? from.toDateString() : from.toDateString()
          )
        }
      }));
    }
    if (name === 'toggledate') {
      setDatePickervalue((prevD) => ({
        ...prevD,
        [name]: {
          from: formatDateforSave(
            typeof from === 'object' ? from.toDateString() : ''
          ),
          to: formatDateforSave(typeof to === 'object' ? to.toDateString() : '')
        }
      }));
    }
    setTo(typeof to === 'object' ? to.toDateString() : '');
    setFrom(typeof from === 'object' ? from.toDateString() : '');
  };

  const ProgressTabProps = {
    closeModal: closeModal
  };

  return (
    <Modal
      className={
        !progressTab
          ? 'baseline-training-modal'
          : 'baseline-training-progress-modal'
      }
      size="small"
      closeIcon={!progressTab ? true : false}
      onClose={closeModal}
      // open={openmodall}
      open={props.openmodal}
      closeOnDimmerClick={false}
    >
      {!progressTab && (
        <Modal.Header className="baseline-training-header">
          {t(de.baselinetraning)}
        </Modal.Header>
      )}
      <Modal.Content className="baseline-training-content">
        {progressTab ? (
          <EmassProgresstab {...ProgressTabProps} />
        ) : (
          <>
            <div className="baseline-instruction-parent">
              <div className="baseline-instruction">
                <div className="baseline-instruction-header">
                  {t(de.howitworks)}
                </div>
                <div className="baseline-instruction-content">
                  <li>{t(de.howitworksone)}</li>
                  <li>{t(de.howitworkstwo)}</li>
                  <li>{t(de.howitworksthree)}</li>
                  <li>{t(de.howitworksfour)}</li>
                  <li>{t(de.howitworksfive)}</li>
                  <li>{t(de.howitworkssix)}</li>
                </div>
              </div>
            </div>
            <div className="baseline-training-daterange">
              <div className="baseline-training-daterange-header">
                {' '}
                {t(de.baselinedaterangeheader)}{' '}
              </div>
              <div className="baseline-training-daterange-subheader">
                {' '}
                {t(de.baselinedaterangesubheader)}{' '}
              </div>
              <div className="choose-training-date-range-div">
                <DatePicker
                  className="choose-training-date-range"
                  required={true}
                  type="daterange"
                  label={t(de.chooseTrainingDateRange)}
                  placeholder="Select"
                  displayFormat="DD MMM YYYY"
                  disablePast={false}
                  closeOnSelection={closeOnSelection}
                  closeOnDocumentClick={closeOnDocumentClick}
                  onRangeSelect={({ to, from }) => {
                    handleBillingCycle(to, from, 'chooseTrainingdate');
                  }}
                  error={error}
                  // disableFuture={true}
                />
                <Badge color={'red'} empty={true} />
              </div>

              <div className="toggle-training-date-range-div">
                <div className="toggle-checkbox">
                  <Checkbox
                    label={t(de.excludeSpecificDateRangeQ)}
                    toggle={true}
                    onChange={() => {
                      setIsdatepickerenable(!isDatepickerenable);
                      if (!isDatepickerenable) {
                        setDatePickervalue({
                          ...datePickervalue,
                          toggledate: {
                            from: '',
                            to: ''
                          }
                        });
                      }
                    }}
                  />
                </div>
                <div className="toggle-datepicker">
                  <DatePicker
                    className="toggle-choose-training-date-range"
                    disabled={!isDatepickerenable}
                    required={true}
                    type="daterange"
                    label={t(de.excludeDateRange)}
                    placeholder="Select"
                    displayFormat="DD MMM YYYY"
                    disablePast={false}
                    closeOnSelection={closeOnSelection}
                    closeOnDocumentClick={closeOnDocumentClick}
                    onRangeSelect={({ to, from }) => {
                      handleBillingCycle(to, from, 'toggledate');
                    }}
                    error={errorExclusionFrom}
                  />
                  <Badge
                    color={'red'}
                    empty={true}
                    className="breakdown-name-badge-css-override"
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </Modal.Content>
      {!progressTab && (
        <Modal.Footer className="baseline-training-footer">
          <Button
            type="secondary"
            content={t(de.back)}
            onClick={closeModal}
          ></Button>
          <Button
            type="primary"
            content={t(de.apply)}
            disabled={issubmitenable}
            onClick={handleSubmit}
          ></Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default EmaasBaselineFormModal;
